import { api, cachedRequest } from '../apiClient';
import { apiCache } from '../cache';
import { Country, Currency } from '../../types';

export const countryService = {
  getCountries: async (forceRefresh: boolean = false): Promise<{ countries: Country[] }> => {
    return cachedRequest(
      'countries_data',
      async () => {
        const response = await api.get('/countries/');
        return response.data;
      },
      30 * 60 * 1000, // 30 minutes
      forceRefresh
    );
  },
  
  getCurrencies: async (forceRefresh: boolean = false): Promise<{ currencies: Currency[] }> => {
    return cachedRequest(
      'currencies_data',
      async () => {
        const response = await api.get('/currencies/');
        return response.data;
      },
      30 * 60 * 1000, // 30 minutes
      forceRefresh
    );
  },
  
  setCountry: async (countryCode: string): Promise<{ country: Country; currency: Currency; message: string }> => {
    const response = await api.post('/country/set/', {
      country_code: countryCode
    });
    
    // Invalidate country-related cache after change
    apiCache.clearByPattern('^(country|currency)');
    
    return response.data;
  },
  
  getCurrentCountry: async (forceRefresh: boolean = false): Promise<{ country: Country | null; currency: Currency | null; country_code: string | null; requires_selection?: boolean }> => {
    return cachedRequest(
      'current_country_data',
      async () => {
        const response = await api.get('/country/current/');
        return response.data;
      },
      5 * 60 * 1000, // 5 minutes
      forceRefresh
    );
  }
};

